import { isValidJSON } from "../../../Dashboard/utility/itemsUtility";
import * as type from "../../types/API/documents";
import { IAction } from "../userMetadataReducer";

const initialState = {
    data: null,
    loading: false,
    error: null,
    documentItems: {},
    total: 0,
    documents: [],
  tableDocumentsByType: {} as Record<string, any>,
    pendingCount: null,
    approveCount: null,
    rejectedCount: null,
    salesItems: {},
    challanItems: {},
};

const getTableDocumentType = (payload: any = {}) => payload?.documentType || "default";

const buildTableQueryKey = (payload: any = {}) => {
    const normalizedPayload = {
        companyId: payload?.companyId ?? null,
        documentType: getTableDocumentType(payload),
        pageSize: payload?.pageSize ?? 20,
        currentPage: payload?.currentPage ?? 1,
        search: payload?.search ?? "",
        dealStatus: payload?.dealStatus ?? [],
        dateRange: payload?.dateRange ?? "",
        docTypeFilter: payload?.docTypeFilter ?? [],
        labels: payload?.labels ?? [],
        documentNumber: payload?.documentNumber ?? "",
        buyerName: payload?.buyerName ?? "",
        field: payload?.field ?? "",
        linkedDocuments: payload?.linkedDocuments ?? "",
        transaction: payload?.transaction ?? "",
    };
    return JSON.stringify(normalizedPayload);
};

export const getDocumentsReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_DOCUMENTS:
            return {
                ...state,
                loading:
                    action.payload?.pageSize || action?.payload?.currentPage || action?.payload?.transaction
                        ? true
                        : state.loading,
            };
        case type.GET_DOCUMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload?.responseData,
                total: action.payload?.responseData?.total ?? state.total,
                error: null,
                documents: action.payload?.responseData?.data,
                rejectedCount: action.payload?.responseData?.rejectedCount || 0,
                approveCount: action.payload?.responseData?.approveCount || 0,
                pendingCount: action.payload?.responseData?.pendingCount || 0,
            };
        case type.GET_DOCUMENTS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};

export const getDocumentByIdReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_DOCUMENTS_BY_ID:
            return {
                ...state,
                loading: true,
            };
        case type.GET_DOCUMENTS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                data: action.payload.responseData,
            };
        case type.GET_DOCUMENTS_BY_ID_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};

export const fetchCurrentDocReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.FETCH_CURRENT_DOC:
            return {
                ...state,
                loading: true,
            };
        case type.FETCH_CURRENT_DOC_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                data: action.payload.responseData,
            };
        case type.FETCH_CURRENT_DOC_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};

export const createDocumentReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.CREATE_DOCUMENT:
            return {
                ...state,
                loading: true,
            };
        case type.CREATE_DOCUMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                data: action.payload.responseData,
            };
        case type.CREATE_DOCUMENT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};

export const getApprovalHistoryReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_APPROVAL_HISTORY:
            return {
                ...state,
                loading: true,
            };
        case type.GET_APPROVAL_HISTORY_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                data: action.payload.responseData, // approval history
            };
        case type.GET_APPROVAL_HISTORY_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};

export const changeApprovalStatusReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.CHANGE_APPROVAL_STATUS:
            return {
                ...state,
                loading: true,
            };
        case type.CHANGE_APPROVAL_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                data: action.payload.responseData, // updated status info
            };
        case type.CHANGE_APPROVAL_STATUS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};

export const getDocumentsByStatusReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case type.GET_DOCUMENTS_BY_STATUS:
            return {
                ...state,
                loading: true,
            };

        case type.GET_DOCUMENTS_BY_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                data: action.payload.responseData,
            };

        case type.GET_DOCUMENTS_BY_STATUS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };

        default:
            return state;
    }
};

export const editDocumentReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.EDIT_DOCUMENT:
            return {
                ...state,
                loading: true,
            };
        case type.EDIT_DOCUMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.responseData.message,
                error: null,
            };
        case type.EDIT_DOCUMENT_FAILED:
            let error = "";
            if (action.payload?.responseData?.error != "") {
                error = action.payload.error;
            }
            return {
                ...state,
                loading: false,
                error: error,
            };
        default:
            return state;
    }
};

export const discardDocumentReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.DISCARD_DOCUMENT:
            return {
                ...state,
                loading: true,
            };
        case type.DISCARD_DOCUMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                data: action.payload.responseData,
            };
        case type.DISCARD_DOCUMENT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};

export const deleteDocumentReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.DELETE_DOCUMENT:
            return {
                ...state,
                loading: true,
            };
        case type.DELETE_DOCUMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                data: action.payload.responseData,
            };
        case type.DELETE_DOCUMENT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};

export const previewDocumentReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.PREVIEW_DOCUMENT:
            return {
                ...state,
                loading: true,
            };
        case type.PREVIEW_DOCUMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                data: action.payload.responseData,
            };
        case type.PREVIEW_DOCUMENT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};

export const getDocumentItemsReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_DOCUMENT_ITEMS:
            return {
                ...state,
            };
        case type.GET_DOCUMENT_ITEMS_SUCCESS:
            return {
                ...state,
                documentItems: action.payload.responseData,
                error: null,
            };
        case type.GET_DOCUMENT_ITEMS_FAILED:
            return {
                ...state,
                error: action.payload.error,
            };
        default:
            return state;
    }
};

export const shortCloseTransactionReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.SHORT_CLOSE_TRANSACTION:
            return {
                ...state,
                loading: true,
            };
        case type.SHORT_CLOSE_TRANSACTION_SUCCESS:
            return {
                ...state,
                error: null,
                loading: false,
                data: action.payload?.responseData?.message,
            };
        case type.SHORT_CLOSE_TRANSACTION_FAILED:
            return {
                ...state,
                error: action.payload.error,
                loading: false,
            };
        default:
            return state;
    }
};

export const getSalesDocumentsItemsReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_SALES_DOCUMENTS_ITEMS:
            return {
                ...state,
                loading: true,
            };
        case type.GET_SALES_DOCUMENTS_ITEMS_SUCCESS:
            return {
                ...state,
                error: null,
                loading: false,
                data: action.payload?.responseData?.itemsData,
                salesItems: action.payload?.responseData?.salesOrderItems,
            };
        case type.GET_SALES_DOCUMENTS_ITEMS_FAILED:
            return {
                ...state,
                error: action.payload.error,
                loading: false,
            };
        default:
            return state;
    }
};

export const getServiceChallanItemsReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_SERVICE_CHALLAN_ITEMS:
            return {
                ...state,
                loading: true,
            };
        case type.GET_SERVICE_CHALLAN_ITEMS_SUCCESS:
            return {
                ...state,
                error: null,
                loading: false,
                data: action.payload?.responseData?.data,
            };
        case type.GET_SERVICE_CHALLAN_ITEMS_FAILED:
            return {
                ...state,
                error: action.payload.error,
                loading: false,
            };
        default:
            return state;
    }
};

export const getTableDocumentsReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_TABLE_DOCUMENTS: {
            const requestPayload = action.payload || {};
            const documentType = getTableDocumentType(requestPayload);
            const queryKey = buildTableQueryKey(requestPayload);
            const documentTypeState = state?.tableDocumentsByType?.[documentType] || { queries: {} };
            const cachedResponse = documentTypeState?.queries?.[queryKey];

            return {
                ...state,
                loading: !cachedResponse,
                error: null,
                total: cachedResponse?.total ?? 0,
                documents: cachedResponse?.documents || [],
                tableDocumentsByType: {
                    ...state.tableDocumentsByType,
                    [documentType]: {
                        ...documentTypeState,
                        loading: !cachedResponse,
                        error: null,
                        lastQueryKey: queryKey,
                        queries: documentTypeState?.queries || {},
                    },
                },
            };
        }
        case type.GET_TABLE_DOCUMENTS_SUCCESS: {
            const requestPayload = action.payload?.requestPayload || {};
            const documentType = getTableDocumentType(requestPayload);
            const queryKey = buildTableQueryKey(requestPayload);
            const documentTypeState = state?.tableDocumentsByType?.[documentType] || { queries: {} };
            const documents = action.payload?.responseData?.data || [];
            const total = action.payload?.responseData?.total ?? 0;

            return {
                ...state,
                loading: false,
                total,
                error: null,
                documents,
                tableDocumentsByType: {
                    ...state.tableDocumentsByType,
                    [documentType]: {
                        ...documentTypeState,
                        loading: false,
                        error: null,
                        lastQueryKey: queryKey,
                        queries: {
                            ...(documentTypeState?.queries || {}),
                            [queryKey]: {
                                documents,
                                total,
                            },
                        },
                    },
                },
            };
        }
        case type.GET_TABLE_DOCUMENTS_FAILED: {
            const requestPayload = action.payload?.requestPayload || {};
            const documentType = getTableDocumentType(requestPayload);
            const documentTypeState = state?.tableDocumentsByType?.[documentType] || { queries: {} };

            return {
                ...state,
                loading: false,
                error: action.payload.error,
                tableDocumentsByType: {
                    ...state.tableDocumentsByType,
                    [documentType]: {
                        ...documentTypeState,
                        loading: false,
                        error: action.payload.error,
                        queries: documentTypeState?.queries || {},
                    },
                },
            };
        }
        default:
            return state;
    }
};

export const createEInvoiceReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.CREATE_EINVOICE:
            return {
                ...state,
                loading: true,
            };
        case type.CREATE_EINVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.responseData.message,
            };
        case type.CREATE_EINVOICE_FAILED:
            let error = "";
            if (action.payload?.responseData?.error != "") {
                error = action.payload.error;
            }
            return {
                ...state,
                loading: false,
                error: error,
            };
        default:
            return state;
    }
};

export const createEWayBillReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.CREATE_EWAYBILL:
            return {
                ...state,
                loading: true,
            };
        case type.CREATE_EWAYBILL_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.responseData.message,
            };
        case type.CREATE_EWAYBILL_FAILED:
            let error = "";
            if (action.payload?.responseData?.error != "") {
                error = action.payload.error;
            }
            return {
                ...state,
                loading: false,
                error: error,
            };
        default:
            return state;
    }
};

export const emailDocumentReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.EMAIL_DOCUMENT:
            return {
                ...state,
                loading: true,
            };
        case type.EMAIL_DOCUMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.responseData.message,
            };
        case type.EMAIL_DOCUMENT_FAILED:
            let error = "";
            if (action.payload?.responseData?.error != "") {
                error = action.payload.error;
            }
            return {
                ...state,
                loading: false,
                error,
            };
        default:
            return state;
    }
};

export const cancelEInvoiceReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.CANCEL_EINVOICE:
            return {
                ...state,
                loading: true,
            };
        case type.CANCEL_EINVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.responseData.message,
            };
        case type.CANCEL_EINVOICE_FAILED:
            return {
                ...state,
                loading: false,
                error:
                    action.payload?.responseData?.error == ""
                        ? ""
                        : "Something went wrong while cancelling the e-invoice. Please try again.",
            };
        default:
            return state;
    }
};

export const getChallanItemsReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_CHALLAN_ITEMS:
            return {
                ...state,
                loading: true,
            };
        case type.GET_CHALLAN_ITEMS_SUCCESS:
            return {
                ...state,
                challanItems: action.payload.responseData,
                error: null,
                loading: false,
            };
        case type.GET_CHALLAN_ITEMS_FAILED:
            return {
                ...state,
                error: action.payload.error,
                loading: false,
            };
        default:
            return state;
    }
};

export const createEWayBillFromEInvoiceReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.CREATE_EWAYBILL_FROM_EINVOICE:
            return {
                ...state,
                loading: true,
            };
        case type.CREATE_EWAYBILL_FROM_EINVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.responseData.message,
            };
        case type.CREATE_EWAYBILL_FROM_EINVOICE_FAILED:
            let error = "";
            if (action.payload?.responseData?.error != "") {
                error = action.payload.error;
            }
            return {
                ...state,
                loading: false,
                error: error,
            };
        default:
            return state;
    }
};

export const cancelEWayBillReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.CANCEL_EWAYBILL:
            return {
                ...state,
                loading: true,
            };
        case type.CANCEL_EWAYBILL_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.responseData.message,
            };
        case type.CANCEL_EWAYBILL_FAILED:
            return {
                ...state,
                loading: false,
                error:
                    action.payload?.responseData?.error == ""
                        ? ""
                        : "Something went wrong while cancelling the E-Way bill. Please try again.",
            };
        default:
            return state;
    }
};

export const saveRfqQuotationReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.SAVE_RFQ_QUOTATION:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case type.SAVE_RFQ_QUOTATION_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.responseData,
                error: null,
            };
        case type.SAVE_RFQ_QUOTATION_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload?.error,
            };
        default:
            return state;
    }
};

